/*
 * DitapPanel을 관리하는 클래스.<br>
 * The class that manages the DitapPanel.
 * @alias DitapPanelManager
 *
 * @constructor
 */
class DitapPanelManager {
  // 패널을 관리하는 클래스 만들기(DitapPanelManager) - 패널을 인스턴스로 받는 클래스
  // 패널은 한번에 한개만 열림
  constructor() {
    this._panels = [];
    this._openPanel = undefined;
    this._ditapPaneManager = undefined;
  }

  /**
   * 관리할 패널 요소들의 배열.<br>
   * Array of panel elements to manage.
   * @type {Element[]}
   */
  set panels(panels) {
    this._panels = panels;
  }
  get panels() {
    return this._panels;
  }

  /**
   * 패널 요소 열기.<br>
   * Open panel element.
   * @type {Element}
   */
  set openPanel(openPanel) {
    this._openPanel = openPanel;
  }
  get openPanel() {
    return this._openPanel;
  }

  /*
   * DitapPopup/DitapPanel을 관리하는 클래스.<br>
   * The class that manages the DitapPopup/DitapPanel.
   * @type {DitapPaneManager}
   */
  set ditapPaneManager(ditapPaneManager) {
    this._ditapPaneManager = ditapPaneManager;
  }
  get ditapPaneManager() {
    return this._ditapPaneManager;
  }

  /**
   * DitapPanel 추가.<br>
   * Add DitapPanel to the panels.
   * @param {DitapPanel} panel 다이탭 패널.<br> DitapPanel.
   */
  addPanel(panel) {
    this.panels.push(panel);
  }

  /**
   * DitapPanel 제거.<br>
   * Remove DitapPanel to the panels.
   * @param {DitapPanel} panel 다이탭 패널.<br> DitapPanel.
   */
  removePanel(removepanel) {
    this.panels = this.panels.filter((panel) => panel !== removepanel);
  }

  /**
   * 패널 배열에 선택 객체 포함 여부 검사.<br>
   * Ensure that selected object is included in the panels.
   * @param {string} selectedId 선택 객체 id.<br> Id of selected object.
   * @returns {boolean} 포함 여부.<br> result value.
   */
  isPanelsById(selectedId) {
    let result = false;
    const selectedPanel = this.panels.find((panel) => panel.id === selectedId);

    if (selectedPanel) {
      result = true;
    }

    return result;
  }

  /**
   * 패널 배열에서 해당 패널 조회.<br>
   * Get the ditapPanel in the panels.
   * @param {string} selectedId 선택 객체 id.<br> Id of selected object.
   * @returns {DitapPanel} 해당 패널 객체. <br> The corresponding panel object.
   */
  getPanelBySelectedObjectId(selectedId) {
    const selectedPanel = this.panels.find((panel) => panel.id === selectedId);

    return selectedPanel;
  }

  /**
   * 해당 패널 열기.<br>
   * Set openPanel.
   * @param {DitapPanel} panel 패널.<br> ditapPanel.
   */
  setOpenPanel(panel) {
    // 기존 오픈된 판넬 숨기기
    if (this.openPanel) {
      this.openPanel.close(this.openPanel.entireWrapper);
    }

    this.openPanel = panel;
  }

  /**
   * 열려있는 패널 닫기.<br>
   * close openPanel.
   */
  closeOpenPanel() {
    if (this.openPanel) {
      if (this.ditapPaneManager) {
        this.ditapPaneManager.removePane(this.openPanel.entireWrapper);
      }
      this.openPanel.close(this.openPanel.entireWrapper);
    }

    this.openPanel = undefined;
  }
}
export default DitapPanelManager;
